import { z } from 'zod';

export const targetSchema = z.object({
  name: z.string().min(1, 'Target name is required'),
  role: z.string().optional(),
  industry: z.string().min(1, 'Please select a target industry'),
  country: z.string().optional(),
  language: z.string().optional(),
});

export type TargetFormData = z.infer<typeof targetSchema>;

export const pitchStrategyEnum = z.enum([
  'Consultative',
  'ROI-Focused',
  'Authority / Expert',
  'Challenger',
  'Relationship',
  'Direct / Action',
], {
  errorMap: () => ({ message: 'Please select a pitch strategy' }),
});

export const pitchSchema = z.object({
  targetLabel: z.string().min(1, 'Target is required'),
  strategy: pitchStrategyEnum,
  text: z.string().optional(),
});

export type PitchFormData = z.infer<typeof pitchSchema>;
